import React from "react";
import { Box, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import CakeIcon from "@mui/icons-material/Cake";
import dayjs from "dayjs";

function ReadonlyField({ icon, label, value, borderLeft, borderTop, span }) {
  return (
    <Box
      sx={{
        px: 2.5,
        py: 2,
        borderLeft: borderLeft ? "1px solid #F1F5F9" : "none",
        borderTop: borderTop ? "1px solid #F1F5F9" : "none",
        gridColumn: span ? `span ${span}` : undefined,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, mb: 0.4 }}>
        {icon}
        <Typography
          sx={{
            fontSize: "0.68rem",
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "#CBD5E1",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Typography sx={{ fontSize: "0.875rem", fontWeight: 500, color: "#1E293B" }}>
        {value}
      </Typography>
    </Box>
  );
}

export default function PersonalInfoReadView({ formData }) {
  return (
    <Box sx={{ px: 3, py: 2.5 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" },
          gap: 0,
          borderRadius: "10px",
          border: "1px solid #F1F5F9",
          overflow: "hidden",
        }}
      >
        <ReadonlyField
          icon={<PersonIcon sx={{ fontSize: 13, color: "#09b2f0" }} />}
          label="Name"
          value={
            [formData.firstName, formData.lastName].filter(Boolean).join(" ") || "—"
          }
        />
        <ReadonlyField
          icon={<ContactPhoneIcon sx={{ fontSize: 13, color: "#09b2f0" }} />}
          label="Phone"
          value={formData.phoneNumber || "—"}
          borderLeft
        />
        <ReadonlyField
          icon={<CakeIcon sx={{ fontSize: 13, color: "#09b2f0" }} />}
          label="Date of Birth"
          value={
            formData.birthday ? dayjs(formData.birthday).format("MMM D, YYYY") : "—"
          }
          borderLeft
        />
        <ReadonlyField
          icon={<HomeIcon sx={{ fontSize: 13, color: "#09b2f0" }} />}
          label="Address"
          value={
            formData.streetAddress
              ? [
                  formData.streetAddress,
                  formData.unitNumber,
                  formData.city,
                  formData.state,
                  formData.zipCode,
                ]
                  .filter(Boolean)
                  .join(", ")
              : "—"
          }
          borderTop
          span={3}
        />
      </Box>
    </Box>
  );
}
